export enum TransferSpeedType {
  'In minutes' = 'In minutes',
  'Within 24 hours' = 'Within 24 hours',
  '1-3 days' = '1-3 days',
  '4-7 days' = '4-7 days',
  '8-14 days' = '8-14 days',
  '15+ days' = '15+ days',
  'Not specified' = 'Not specified',
}
